import { render, staticRenderFns } from "./mobileShowPhone.vue?vue&type=template&id=893faec8&scoped=true&"
import script from "./mobileShowPhone.vue?vue&type=script&lang=js&"
export * from "./mobileShowPhone.vue?vue&type=script&lang=js&"
import style0 from "./mobileShowPhone.vue?vue&type=style&index=0&id=893faec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893faec8",
  null
  
)

component.options.__file = "mobileShowPhone.vue"
export default component.exports